import { observer } from "mobx-react";

import Faqed from "components/UI/Faqed/Faqed";
import InputLink from "components/InputLink/InputLink";
import UploadFile from "components/UploadFile/UploadFile";
import { CategoryInput } from "../componentsSettingsStep/CategoryInput/CategoryInput";
import { Phrase } from "../componentsSettingsStep/Phrase/Phrase";
import CityInput from "../componentsSettingsStep/CityInput/CityInput";
import CheckBox from "components/UI/CheckBox/CheckBox";

import AppStore from "AppStore";

import { getDativeCase } from "utils/helpers";

import "./IsMobileSettingsStep.scss";

export const IsMobileSettingsStep = observer(
  ({
    store,
    modeId,
    needFullParams,
    nameSite,
    linkRef,
    categoryRef,
    cityRef,
    searchPhrasesRef,
    screenshotRef,
    freeOnlineServiceRef,
    onChangeLinkToAd,
    onChangeAddress,
    descriptionScreenshot,
    descriptionCategory,
    descriptionCity,
    iconUploadFile,
    isPresave,
  }) => {
    return (
      <div className="market-step1-mobile">
        <div className="market-step1-mobile__link_settings">
          {needFullParams && (
            <div className={`market-step1-mobile__link_settings-screen ${AppStore.uploadedFileError ? " error" : ""}`} ref={screenshotRef}>
              <Faqed text={descriptionScreenshot}>
                <p className="market-step1-mobile__label">
                  Прикрепите скриншот объявления
                </p>
              </Faqed>
              <UploadFile 
                title="Прикрепите скриншот"
                icon={iconUploadFile} 
                className="avito-upload-file__add-button" 
              />
            </div>
          )}
         {!store.market.isPharmacy ? 
            <div ref={linkRef}>
              {!store.market.isMusicPlatform && (
                <>
                  <Faqed text="Укажите ссылку формата https://">
                    <p className="market-step1-mobile__label">{store.market.targetLinkCommentShort}</p>
                  </Faqed>
                  <InputLink
                    defaultValue={store.linkToAd}
                    onChange={onChangeLinkToAd}
                    errortext={store.linkError}
                  />
                </>
              )}

              {store.market.isMusicPlatform && (
                <div>
                  <div className="market-step1-mobile__music-fields">
                    <div>
                      <p className="market-step1-mobile__label">Название трека</p>
                      <InputLink
                        placeholder="Точное название, как на платформе"
                        defaultValue={store.trackTitle}
                        onChange={(e) => store.setTrackTitle(e.target.value)}
                        errortext={store.trackTitleError}
                      />
                    </div>
                    <div>
                      <p className="market-step1-mobile__label">Название альбома</p>
                      <InputLink
                        placeholder="Точное название, как на платформе"
                        defaultValue={store.albumTitle}
                        onChange={(e) => store.setAlbumTitle(e.target.value)}
                        errortext={store.albumTitleError}
                      />
                    </div>
                    <div>
                      <p className="market-step1-mobile__label">Исполнитель(-и)</p>
                      <InputLink
                        placeholder="Если исполнителей несколько, укажите всех"
                        defaultValue={store.musician}
                        onChange={(e) => store.setMusician(e.target.value)}
                        errortext={store.musicianError}
                      />
                    </div>
                    <div>
                      <p className="market-step1-mobile__label">{isPresave ? "Ссылка на пресейв" : "Ссылка на трек/пресейв"}</p>
                      <InputLink
                        placeholder="Введите ссылку в формате https://..."
                        defaultValue={store.linkToAd}
                        onChange={(e) => store.setLinkToAd(e.target.value)}
                        errortext={store.linkError}
                      />
                    </div>
                  </div>
                </div>
              )}
              {store.market.id === "avito" && store.currentCalculator.actions.some(action => action.type === 'MAIN.REVIEW' && action.count > 0) && 
                <div className="market-step1-mobile__check" ref={freeOnlineServiceRef}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                    <path d="M8.80092 8.67034L5.73235 6.42441L6.13714 10.185H3.81286L4.21765 6.41135L1.14908 8.67034L0 6.63333L3.48642 5.10558L0 3.57782L1.14908 1.52776L4.23071 3.83898L3.81286 0H6.13714L5.71929 3.83898L8.80092 1.52776L9.95 3.57782L6.47664 5.10558L9.95 6.63333L8.80092 8.67034Z" fill="#FF7373"/>
                  </svg>
                  <CheckBox
                    classes={["market-step1-mobile__check-link", store.freeOnlineServiceError ? "error" : ""]}
                    title={<><b>Я проверил(-а),</b> что в объявлении по ссылке есть бесплатная онлайн-услуга</>}
                    checked={store.isFreeOnlineService}
                    onClick={() => store.setIsFreeOnlineService(!store.isFreeOnlineService)}
                  />
                </div>                
              }
            </div>
          :
            <div className="market-step1-mobile__link_settings-link">
              <p className="market-step1-mobile__label">{store.market.targetLinkComment}</p>
              <InputLink
                placeholder="Например, 100 мл"
                defaultValue={store.dosage}
                onChange={(e) => { store.setDosage(e.target.value) }}
              />
              <p className="market-step1-mobile__note">Поле необязательно для заполнения</p>
            </div>
            }
          {store.market.hasSearchPhrase && (
            <div ref={searchPhrasesRef}>
              <p className="market-step1-mobile__label">{store.currentCalculator.mode.stepPhrase2}</p>
              <Phrase store={store} maxPhrases={1} />
            </div>
          )}
          {needFullParams && (
            <>
              {!store.market.isPharmacy &&
                <div ref={categoryRef}>
                  <Faqed text={descriptionCategory}>
                    <p className="market-step1-mobile__label">
                      Укажите категорию продвижения поисковой фразы
                    </p>
                  </Faqed>
                  <CategoryInput store={store} error={store.categoryError} />
                </div>
              }
              <div ref={cityRef}>
                <Faqed text={descriptionCity}>
                  {!store.market.isPharmacy 
                    ? <p className="market-step1-mobile__label">Укажите город продвижения поисковой фразы</p> 
                    : <p className="market-step1-mobile__label">Укажите регион продвижения</p>
                  }
                </Faqed>
                <CityInput onChange={onChangeAddress} error={store.cityError} />
              </div>
              <div ref={searchPhrasesRef}>
                {!store.market.isPharmacy ?
                <>
                  <p className="market-step1-mobile__label">Какие поисковые фразы надо продвинуть на {getDativeCase(nameSite)}?</p>
                  <p className="market-step1-mobile__note">Делайте более <span>точные поисковые запросы</span> и не используйте запросы с одним поисковым словом</p>
                  <Phrase store={store} />
                </> 
              : 
                <>
                  <p className="market-step1-mobile__label">Поисковый запрос</p>
                  <p className="market-step1-mobile__note">Товар <b>должен быть в ТОП-5 выдачи</b> по запросу</p>
                  <Phrase store={store} maxPhrases={4} />
                </>
              }   
              </div>
            </>
          )}
          {store.market.isPharmacy &&
            <div className="market-step1-mobile__request">
              <div className="market-step1-mobile__request-title">
                <p className="market-step1-mobile__label">Комментарий для исполнителя</p>
              </div>
              <textarea
                className="market-step1-mobile__textarea"
                placeholder="Укажите уникальный фильтр, чтобы облегчить поиск товара исполнителями"
                value={store.commentComment}
                onChange={(e) => {
                  store.setCommentComment(e.target.value);
                }}
              />
              <p className="market-step1-mobile__note">Поле необязательно для заполнения</p>
            </div>
          }
        </div>
      </div>
    );
  }
);
